<script>
import visitService from "@/services/visit";
import { toUpperMixin }  from "@/utils/mixins/toUpper";

export default {
  name: "massactionSignin",
  title: "Mass action signin",
  data() {
    return {
      submitBtnValue: "CONTINUE",
      area: null,
      site: "",
      siteOptions: [],
      areaOptions: [],
      usersId: [],
      isLoading: true,
    };
  },
  methods: {
    onSiteSelect(selectedSite) {
      this.area = null;
      this.areaOptions = selectedSite ? selectedSite.areas : [];
    },
    submitHandler() {
      if (this.site?.id && this.area?.id) {
        this.$emit("massActionSigninHandler", {
          area_id: this.area.id,
          site_id: this.site.id,
          site_name: this.site.label,
        });
      }
    },
  },
  watch: {
    site(site) {
      if (site.areas.length == 1 && !site.areas[0]?.children?.length) this.area = site.areas[0];
      this.areaOptions = site.areas
    },
  },
  async beforeMount() {
    try {
      this.submitBtnValue = toUpperMixin(this.$t("common.continue"));
      let { data: sites } =  await visitService.getAllSitesWithAreasByEntityId();
      this.siteOptions = sites;
      if (sites.length == 1) this.site = sites[0];
    } catch (e) {
      console.error("Could not fetch sites , ", e);
    } finally {
      this.isLoading = false;
    }
  },
};
</script>

<template>
  <div>
    <!-- start::modal-header -->
    <div class="modal-header-container">
      <h4 class="modal-title">{{$t('common.signInOut')}}</h4>
    </div>
    <svg
        style="float: inline-end; position: relative; top:-55px"
        @click="$bvModal.hide('signinMassaction')"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
          fill="#F46A6A"
        />
      </svg>
    <!-- end::modal-header -->

    <!-- start::modal-content -->
    <div class="site-area-container d-flex flex-column">
      <!-- start::site section -->
      <vp-multiselect
        class="vp-mb-16 site-multiselect"
        width="416"
        label="name"
        trackBy="id"
        title="Site"
        v-model="site"
        :showPlaceholderIcon="true"
        dropDownStyle="relative"
        :options="siteOptions"
        :maxHeight="177"
        :placeholder="$t('common.site')"
        :show-labels="false"
        :allowEmpty="false"
        :disabled="isLoading"
        :showOptionsBorder="true"
        :loading="isLoading && !site"
        @select="onSiteSelect"
      />
      <!-- end::site section -->

      <!-- start::area section-->
      <vp-treeselect
          zIndex="10"
          :flatMode=false
          :showPlaceholderIcon = true
          width="416"
          :showOptionsBorder="true" 
          :showNoResults="true"
          v-model="area"
          :options="areaOptions"
          :label="$t('common.area')"
          dropDownStyle="relative"
          :backspaceRemoves="false"
          :isMultiple="false"
          valueFormat="object"
          :disabled="!site"
        />
      <!-- end::area section -->
    </div>
    <!-- end::modal-header -->

    <!-- start::modal footer -->
    <!-- start::submit button -->
    <button
      @click="submitHandler"
      v-b-modal="'pageLoader'"
      :disabled="!site || !area"
      class="continue-btn"
    >
      {{ submitBtnValue }}
    </button>
    <!-- end::submit button -->
    <!-- end::modal footer -->
  </div>
</template>

<style lang="scss" scoped>
::v-deep {
  .continue-btn {
    border: 0;
    height: 44px;
    width: 415px;
    border-radius: 22px;
    background: #103f5e;
    font-size: 16px;
    font-weight: 700;
    line-height: 17px;
    letter-spacing: 0.25px;
    text-align: center;
    color: #ffffff;
    margin-top: 40px;
    margin-inline-end: auto;
    margin-bottom: 17px;
    margin-inline-start: -4px;
  }
  .continue-btn:disabled {
    opacity: 0.4 !important;
  }

  .modal-header-container {
    // margin-inline-start: 144px;
    margin-bottom: 35px;
    margin-top: -5px;
    .modal-title {
      width: fit-content;
      margin: auto;
    }
  }
  .custom-label {
    position: absolute;
    margin-inline-start: 48px;
    margin-top: 9px;
    z-index: 2;
    color: #103f5e;
    font-size: 12px;
    opacity: 0.8;
    font-weight: 700;
    line-height: 17px;
    letter-spacing: 0.25px;
    opacity: 0.8;
  }
  .search-svg {
    position: absolute;
    z-index: 55;
    margin: 20px 15px;
  }
  .disabled-opacity {
    opacity: 0.4;
  }
}
#signinMassaction___BV_modal_content_ {
  border-radius: 26px;
}
</style>
